import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property, query, queryAssignedNodes, state } from 'lit/decorators.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import { gridBreakpoints, gridColumnGap } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/breakpoints.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { debounce } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debounce.js';
import promoImageStyles from './image.scss.js';
import contentBlockIconSetStyles from './content-block.scss.js';
import styles from './promo.scss.js';
/**
 * @param Base The base class.
 * @returns Promo component.
 *
 * @slot heading
 * @slot
 */
export class Promo extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Determine if promo is fullWidth.
         */
        this.fullWidth = false;
        /**
         * Determine if promo is two column, with link.
         */
        this.standaloneLink = false;
        /**
         * The size of the image promo
         */
        this.size = 'large';
        /**
         * The promo type.
         */
        this.background = 'primary';
        /**
         * The promo style.
         */
        this.variant = 'basic';
        this.order = 'image-right';
        this.emitConnectedCallback = false;
    }
    static get styles() {
        return [styles];
    }
    get isMobile() {
        return !window.matchMedia(`(min-width: ${gridBreakpoints.md}px)`).matches;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
    }
    async firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        window.addEventListener('resize', debounce(this.setImageWidth.bind(this), 200));
    }
    async updated() {
        this.setImageWidth();
    }
    setImageWidth() {
        var _a, _b;
        const distanceToScreenLeft = ((_a = this.promoImageHolder) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()['left']) || 0;
        const distanceToScreenRight = ((_b = this.promoImageHolder) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()['right']) || 0;
        const distanceToScreen = this.order === 'image-left' ? distanceToScreenRight : this.clientWidth - distanceToScreenLeft;
        this.promoImage.forEach((image) => (image.style.width = this.isMobile ? '100%' : `calc(${distanceToScreen}px + ${gridColumnGap}px)`));
    }
    render() {
        return html `<div class="container"><slot name="image" @slotchange="${(event) => {
            addStyleSheetToElements(event.target.assignedElements(), promoImageStyles);
        }}"></slot><div></div><div class="promo-${this.variant}"><div class="icon-wrapper"><slot name="icon"></slot><div class="content-wrapper"><slot name="heading"></slot><div class="inner-content-wrapper"><slot @slotchange="${(event) => {
            const name = event.target.assignedElements()[0].constructor.name.toLowerCase();
            if (name === 'contentblock') {
                addStyleSheetToElements(event.target.assignedElements(), contentBlockIconSetStyles);
            }
        }}"></slot></div></div></div><slot name="link"></slot></div></div>`;
    }
}
__decorate([
    state()
], Promo.prototype, "isMobile", null);
__decorate([
    property({ type: Boolean, attribute: 'full-width' })
], Promo.prototype, "fullWidth", void 0);
__decorate([
    property({ type: Boolean, attribute: 'standalone-link' })
], Promo.prototype, "standaloneLink", void 0);
__decorate([
    property({ reflect: true })
], Promo.prototype, "size", void 0);
__decorate([
    property({ reflect: true })
], Promo.prototype, "background", void 0);
__decorate([
    property({ reflect: true })
], Promo.prototype, "variant", void 0);
__decorate([
    query('[name="image"]')
], Promo.prototype, "promoImageHolder", void 0);
__decorate([
    queryAssignedNodes('image', true)
], Promo.prototype, "promoImage", void 0);
__decorate([
    property({ reflect: true })
], Promo.prototype, "order", void 0);
__decorate([
    property()
], Promo.prototype, "imagePosition", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], Promo.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=promo.js.map